
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-grow99x-text text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="flex items-center justify-center mb-4">
            <span className="text-xl font-bold font-poppins">
              <span className="text-grow99x-orange">Grow</span>
              <span className="text-white">99X</span>
            </span>
          </div>
          
          <p className="text-gray-300 mb-4">
            Your local digital partner to grow your business 99 more times.
          </p>
          
          <div className="mt-8">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Grow99X. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
